import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DxTextBoxComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ConstantsService } from 'src/app/services/constants.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { VoucherDetails } from '../../model/voucher-details.model';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-voucher-input',
  templateUrl: './voucher-input.component.html',
  styleUrls: ['./voucher-input.component.css'],
})
export class VoucherInputComponent implements OnInit, OnDestroy {
  VoucherChanged$: Subject<VoucherDetails> = new Subject<VoucherDetails>();
  @ViewChild(DxTextBoxComponent) voucherCode: DxTextBoxComponent;
  @Output() VoucherChanged: EventEmitter<VoucherDetails> = new EventEmitter<VoucherDetails>();

  constructor(private transactionService: TransactionService, public Constants: ConstantsService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.VoucherChanged$?.unsubscribe();
  }

  onSelectedVoucherChanged(e) {
    var voucherCode = this.voucherCode.instance.option('text');
    if (voucherCode && voucherCode.length > 4) {
      this.transactionService
        .GetVoucher(voucherCode)
        .pipe(take(1))
        .subscribe((v) => {
          this.VoucherChanged.next(v);
        });
    }
  }

  public reset() {
    this.voucherCode?.instance?.option('value', '');
  }
}
